// Authority base baked per brand; config.js may override (ADR-0064).
declare const __AUTH_BASE__: string
declare const __FORGOT_PASSWORD_URL__: string

export const BUILD_AUTH_BASE: string = __AUTH_BASE__
export const BUILD_FORGOT_PASSWORD_URL: string = __FORGOT_PASSWORD_URL__

export interface AppConfig {
  challengeEndpoint: string
  sessionStatusEndpoint: string
  sessionContextEndpoint: string
  logoutUrl: string
  forgotPasswordUrl: string | null
  completeSignoutUrl: string
}

interface ConfigHost {
  __APP_CONFIG__?: {
    endpoints?: { challengeUrl?: unknown }
    links?: { forgotPasswordUrl?: unknown }
  }
}

// Unsubstituted ${VAR} counts as absent.
function usable(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null
  }
  const trimmed = value.trim()
  return trimmed === '' || /^\$\{[^}]*\}$/.test(trimmed) ? null : trimmed
}

// The authority operations this app may call.
export const CHALLENGE_PATH = '/login/challenge'
export const SESSION_STATUS_PATH = '/session/status'
export const SESSION_CONTEXT_PATH = '/session/context'
export const LOGOUT_PATH = '/Auth/Logout'
export const COMPLETE_SIGNOUT_PATH = '/connect/complete-signout'

// NZ mounts the authority under /app, AU under /api.
const CHALLENGE_SUFFIX = /\/login\/challenge\/*$/

export function authorityBase(challengeEndpoint: string, fallback: string = BUILD_AUTH_BASE): string {
  return CHALLENGE_SUFFIX.test(challengeEndpoint)
    ? challengeEndpoint.replace(CHALLENGE_SUFFIX, '')
    : fallback
}

export function readAppConfig(
  host: ConfigHost = globalThis as ConfigHost,
  buildBase: string = BUILD_AUTH_BASE,
  buildForgotPasswordUrl: string = BUILD_FORGOT_PASSWORD_URL,
): AppConfig {
  const challengeEndpoint = usable(host.__APP_CONFIG__?.endpoints?.challengeUrl) ?? buildBase + CHALLENGE_PATH
  const base = authorityBase(challengeEndpoint, buildBase)

  return {
    challengeEndpoint,
    sessionStatusEndpoint: base + SESSION_STATUS_PATH,
    sessionContextEndpoint: base + SESSION_CONTEXT_PATH,
    logoutUrl: base + LOGOUT_PATH,
    forgotPasswordUrl: usable(host.__APP_CONFIG__?.links?.forgotPasswordUrl) ?? usable(buildForgotPasswordUrl),
    completeSignoutUrl: base + COMPLETE_SIGNOUT_PATH,
  }
}
